var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.0571,
    height: 42.0571,
    rx: 21.0286,
    fill: "#20BF55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1608 30.1516V28.1562C26.1608 27.0978 25.7404 26.0827 24.992 25.3343C24.2436 24.5859 23.2285 24.1654 22.1701 24.1654H14.1885C13.1301 24.1654 12.115 24.5859 11.3666 25.3343C10.6182 26.0827 10.1978 27.0978 10.1978 28.1562V30.1516",
    stroke: "white",
    strokeWidth: 1.99539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1792 20.1747C20.3832 20.1747 22.17 18.3879 22.17 16.1839C22.17 13.9798 20.3832 12.1931 18.1792 12.1931C15.9751 12.1931 14.1884 13.9798 14.1884 16.1839C14.1884 18.3879 15.9751 20.1747 18.1792 20.1747Z",
    stroke: "white",
    strokeWidth: 1.99539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1469 30.1513V28.1559C32.1462 27.2716 31.8519 26.4127 31.3102 25.7138C30.7685 25.015 30.01 24.5159 29.1538 24.2948",
    stroke: "white",
    strokeWidth: 1.99539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1631 12.3225C26.0216 12.5423 26.7824 13.0415 27.3258 13.7415C27.8691 14.4415 28.1641 15.3025 28.1641 16.1886C28.1641 17.0747 27.8691 17.9356 27.3258 18.6356C26.7824 19.3356 26.0216 19.8348 25.1631 20.0546",
    stroke: "white",
    strokeWidth: 1.99539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9446,
    height: 23.9446,
    fill: "white",
    transform: "translate(9.20001 9.19995)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGroup);
export default __webpack_public_path__ + "static/media/person-group.a7b196cd188bff56579664781ed71016.svg";
export { ForwardRef as ReactComponent };